import { render } from "./HeroiconsSolidCog.vue?vue&type=template&id=17f532f6"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCog.vue"]])

export default __exports__